export const REGIONS_NAME = 'name_json';
export const REGIONS_CODE = 'code';
